import type { ViewType } from '../../../../../../../../common/types/context';
import type {
	FieldMap,
	FieldMapFromIframe,
	FieldType,
} from '../../../../../../../../common/types/field';
import { getSupportedFieldConfiguration } from '../../../../../../../../controllers/view-configuration';

export const filterFieldTypeBasedOnScopes = (
	viewType: ViewType,
	fieldType: FieldType,
	moduleScopes: readonly string[],
): boolean | 0 => {
	const fieldRequiredScopes = getSupportedFieldConfiguration(viewType, fieldType)?.requiredScopes;

	if (!fieldRequiredScopes) {
		return true;
	}

	const includeCoarseScopes = () =>
		fieldRequiredScopes.coarse.length &&
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore - requiredScope is not types on CI somehow
		fieldRequiredScopes.coarse.every((requiredScope) => moduleScopes.includes(requiredScope));

	const includeGranularScopes = () =>
		fieldRequiredScopes.granular.length &&
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore - requiredScope is not types on CI somehow
		fieldRequiredScopes.granular.every((requiredScope) => moduleScopes.includes(requiredScope));

	return includeCoarseScopes() || includeGranularScopes();
};

export const filterFormDataBasedOnScopes = (
	formData: FieldMap,
	viewType: ViewType,
	moduleScopes: readonly string[],
): FieldMap => {
	const formDataAsArray = Object.entries(formData);
	const filteredFormDataArray = formDataAsArray.filter(([_, value]) => {
		if (!value?.fieldType) {
			return false;
		}

		const { fieldType } = value;

		return filterFieldTypeBasedOnScopes(viewType, fieldType, moduleScopes);
	});
	return Object.fromEntries(filteredFormDataArray);
};

export const filterFieldsChangesBasedOnScopes = (
	fieldsChanges: FieldMapFromIframe,
	formData: FieldMap,
	viewType: ViewType,
	moduleScopes: readonly string[],
): FieldMapFromIframe => {
	const fieldsChangesAsArray = Object.entries(fieldsChanges);
	const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId]) => {
		const field = formData[fieldId];
		const fieldType = field?.fieldType;

		if (!fieldType) {
			return false;
		}

		return filterFieldTypeBasedOnScopes(viewType, fieldType, moduleScopes);
	});
	return Object.fromEntries(filteredFieldsChangesArray);
};
